module.exports = __webpack_public_path__ + "img/avatar7.c16a2c2d.png";